module.exports = __webpack_public_path__ + "img/logo_sphn.bbd76257.png";